import  {get, post} from '../utils/request'

// ------------------------- 测评首页 ------------------------------
// 列表数据
export const SystemList = (params)=>get('/api/assessment-config/page/student',params)

// 下载/查看 学生报告
export const ReportPdf = (params)=>get('https://yingde_api.ydassess.com/health/report/download',params)


// ------------------------- 查看报告 ------------------------------
// 列表数据
export const HaveBeenSystemList = (params)=>get('/api/userinfo',params)


// ------------------------- 学习资源 - 补充课程 ------------------------------
// 列表数据
export const BccourseList = (params)=>get('/api/userinfo',params)

// 查询
export const BccourseSearch = (params)=>get('/api/userinfo',params)


// ----------------------------------------------------------------------------------------------------

// 学习资源 列表
export const ResourceList = (url,params)=>get(url,params)

// 课程详情
export const ResourceDetail = (url,params)=>get(url,params)

// 补充课程页 下拉列表
export const BccourseDroplist = (params)=>get('https://yingde_api.ydassess.com/courses/public/attrs',params)

// 保存心得
export const saveFeelings = (data)=>post('https://yingde_api.ydassess.com/courses/public/feeling',data)

// 判断当前用户是否做了测评
export const determine = (url,data) => get(url,data)

// 根据学校id查询学校人数
export const studentNum = (url,params) => get(url,params)

// 根据学校id查询已完成测评学生人数
export const getSussessNum = (data) => post('https://yingde_api.ydassess.com/health/school/joined/numbers',data)



// WEBPACK FOOTER //
// ./src/api/studentApi.js